import { ISubscription } from 'models/subscriptions.model'

export const compareSubscriptionList = (
  prevValue: ISubscription[],
  newValue: ISubscription[],
): boolean =>
  prevValue.length === newValue.length &&
  prevValue.every((prevItem) =>
    newValue.find((newItem) => prevItem.planId === newItem.planId),
  )
